import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import './ComingSoon.css';

function ComingSoon() {
  return (
    <div className="coming-soon-container">
      <InboxOutlined className="coming-soon-icon" />
      <p className="coming-soon-message">
        This functionality is not ready yet. Our team is working on it and it will be available soon.
      </p>
    </div>
  );
}

export default ComingSoon;
